import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import * as actionsMalhas from '../../../store/malha/actions';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  codigo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({ saveMalha, updateMalha, malhas, open, id, onClose }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) setValues(malhas.filter(a => a.id === id)[0]);
  }, [id, malhas]);

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros);
    if (!erros) {
      if (values.id) updateMalha(values);
      else saveMalha(values);
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Malha"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.codigo)}
            isRequired
            label="Código"
            name="codigo"
            onChange={handleChange}
            value={values.codigo || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.nome)}
            isRequired
            label="Nome"
            name="nome"
            onChange={handleChange}
            value={values.nome || ''}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={4}
            multiline
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  saveMalha: PropTypes.func.isRequired,
  updateMalha: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  malhas: PropTypes.array,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsMalhas,
}, dispatch);

export default connect(null, mapDispatchToProps)(withRouter(Formulario));
